import { Inject, Component, Input, OnInit, AfterViewInit, ElementRef, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from 'rxjs';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: "list-marquee",
    templateUrl: "./list-marquee.template.html",
    styleUrls: ["./list-marquee.style.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ListMarquee implements OnInit {
    @Input() item: any;
    public hasSponsorImage : boolean = false;
    public hasHeaderImage : boolean = false;
    //private imageSub:Observable<any>;
    private imageCollection: Array<string> = this.appSettings['LIST_IMAGE_FALLBACK_COLLECTION'];
    private _randomImage:string;
    private get randomImage():string{
        if(!this._randomImage)
            this._randomImage = this.imageCollection[Math.floor(Math.random() * this.imageCollection.length)]
        
        return this._randomImage;
    }

    get image():string {
        /*if(this.item && this.item.meta && this.item.meta.images && this.item.meta.images.length > 0)
        {
            return this.item.meta.images[1].url;
        }*/
        if(this.item && this.item.meta && this.item.meta.images)
        {            
            const images = Array.from(this.item.meta.images);
            let image = images.find(img => img["name"] == "thumb_1280x_header");
            if(image)
            {
                this.hasHeaderImage = true;
                return 'url('+image["url"]+')';
            }
        }
            
        return 'url('+ this.randomImage + ')';
    }

    constructor(
        @Inject(APP_SETTINGS) private appSettings: Object,
        private el: ElementRef
    ) { }

    ngOnInit() {
        
    }

    ngAfterViewInit() {
        if (this.el && this.el.nativeElement && this.el.nativeElement.classList) {
            this.el.nativeElement.classList.add('ready');
        }
    }
}    


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/list-marquee/list-marquee.component.ts